<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2903_28137)">
      <path d="M0.666992 5.24044C0.667216 6.30221 1.03523 7.33106 1.70833 8.15169C2.38144 8.97233 3.31798 9.53397 4.35841 9.74093C4.41767 9.08355 4.58621 8.44069 4.85708 7.83889C4.05408 7.5673 3.53799 6.95072 3.41699 6.07539H2.95866V5.68452H3.38583V5.28631C3.38583 5.24411 3.38583 5.20098 3.38949 5.16245H2.95866V4.77066H3.42708C3.63333 3.62558 4.52891 2.94661 5.87458 2.94661C6.16424 2.94661 6.41541 2.97505 6.62533 3.0246V3.69715C6.38015 3.64255 6.12937 3.61729 5.87824 3.62191C5.03583 3.62191 4.46841 4.04948 4.28874 4.77066H6.04599V5.16245H4.23099C4.22824 5.20465 4.22824 5.25145 4.22824 5.29732V5.68452H6.04599V6.07631H4.26949C4.37766 6.62866 4.69849 7.02137 5.19074 7.20396C5.6734 6.40383 6.33719 5.72846 7.12855 5.23231C7.91992 4.73617 8.8167 4.43314 9.74658 4.34768C9.52176 3.23335 8.89177 2.24219 7.97863 1.56619C7.06548 0.890197 5.93419 0.577482 4.80387 0.688621C3.67356 0.79976 2.62468 1.32684 1.86041 2.16777C1.09614 3.0087 0.670876 4.10362 0.666992 5.24044ZM15.3337 10.2869C15.3337 11.6253 14.8025 12.9088 13.857 13.8552C12.9115 14.8016 11.6291 15.3333 10.292 15.3333C8.95486 15.3333 7.67249 14.8016 6.727 13.8552C5.7815 12.9088 5.25033 11.6253 5.25033 10.2869C5.25033 8.94847 5.7815 7.66489 6.727 6.7185C7.67249 5.77211 8.95486 5.24044 10.292 5.24044C11.6291 5.24044 12.9115 5.77211 13.857 6.7185C14.8025 7.66489 15.3337 8.94847 15.3337 10.2869ZM8.22949 11.4998C8.29274 12.266 8.91333 12.8624 10.0298 12.933V13.4982H10.5248V12.9294C11.6789 12.8505 12.3545 12.2504 12.3545 11.3787C12.3545 10.5851 11.8384 10.1768 10.9153 9.96573L10.5248 9.87398V8.33619C11.0198 8.39124 11.3352 8.65458 11.4103 9.01975H12.2793C12.2152 8.28206 11.5652 7.70493 10.5248 7.64162V7.0755H10.0298V7.65263C9.04349 7.74714 8.37249 8.32426 8.37249 9.14087C8.37249 9.86297 8.87116 10.3226 9.70166 10.5107L10.0298 10.5887V12.2219C9.52199 12.1485 9.18649 11.8769 9.11041 11.4998H8.22949ZM10.0262 9.76112C9.53849 9.65102 9.27449 9.42714 9.27449 9.08949C9.27449 8.7133 9.55958 8.42978 10.0298 8.3472V9.7602H10.0252L10.0262 9.76112ZM10.5963 10.719C11.1876 10.8521 11.4607 11.0677 11.4607 11.4494C11.4607 11.8843 11.1216 12.1834 10.5257 12.2385V10.7025L10.5963 10.719Z" :fill="iconColor"/>
    </g>
    <defs>
      <clipPath id="clip0_2903_28137">
        <rect :width="width" :height="height" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "IconCurrencyExchangeMenu",
    },
    width: {
      type: [Number, String],
      default: 16,
    },
    height: {
      type: [Number, String],
      default: 16,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
